import { createEffect, createEvent } from 'effector';

import { apiFetch } from '@m/utils/http';

/**
 * Gets list of enterprises that the logged in
 * user has access to.
 */
export const getAvailableEnterprises = createEffect(() => apiFetch('/portal/enterprises'));

/**
 * It's possible for a user to be linked to more than
 * one enterprise. We currently don't support this,
 * but this action will be useful for impementing an
 * enterprise account switching component
 */
export const setSelectedEntepriseId = createEvent<number | null>();

/**
 * Update the auto pay setting for a selected enterprise
 */
export const updateAutoPaySetting = createEvent<{ enabled: boolean; enterpriseId: number }>();
